import React, { useState } from "react";
import ConfirmationModal from "./ConfirmationModal"; // ✅ تأكد من المسار الصحيح

interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  type?: "primary" | "secondary";
  htmlType?: "button" | "submit" | "reset";
  disabled?: boolean;
  className?: string;

 
  confirm?: boolean;
  confirmTitle?: string;
  confirmMessage?: string;
  confirmText?: string;
  cancelText?: string;
}

const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  type = "primary",
  htmlType = "button",
  disabled = false,
  className = "",
  confirm = false,
  confirmTitle = "تأكيد العملية",
  confirmMessage = "هل أنت متأكد من المتابعة؟",
  confirmText = "نعم",
  cancelText = "إلغاء",
}) => {
  const [showModal, setShowModal] = useState(false);

  const handleClick = () => {
    if (confirm) {
      setShowModal(true);
    } else {
      onClick?.();
    }
  };

  const handleConfirm = () => {
    setShowModal(false);
    onClick?.();
  };

  const baseStyles = "rounded-lg py-2 px-4 text-md font-bold w-full transition";
  const primaryStyles =
    "bg-red-700 text-white hover:bg-red-800 transition-colors duration-300";
  const secondaryStyles =
    "border border-red-600 text-red-700 bg-white hover:bg-red-100 transition-colors duration-300";

  const finalClassName = `${baseStyles} ${
    type === "primary" ? primaryStyles : secondaryStyles
  } ${disabled ? "opacity-50 cursor-not-allowed" : ""} ${className}`;

  return (
    <>
      <button
        type={htmlType}
        onClick={handleClick}
        disabled={disabled}
        className={finalClassName}
      >
        {children}
      </button>

      {confirm && (
        <ConfirmationModal
          show={showModal}
          title={confirmTitle}
          message={confirmMessage}
          confirmText={confirmText}
          cancelText={cancelText}
          onConfirm={handleConfirm}
          onCancel={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default Button;
